<template>

	<div>
		<template v-if="device!='pc'">
			<template v-for="(item , index) in report">
				<div :key="index">
					<van-divider>{{index}}</van-divider>
					<van-grid :square="true">
						<template v-for="(_item,_index) in item">
							<van-grid-item @click="open(_item.id,_item.component,_item.name)" :key="_index"
								:text="_item.name">
								<template #icon>
									<van-icon color="#67C23A" size="20" name="chart-trending-o" />
								</template>
							</van-grid-item>
						</template>
					</van-grid>
				</div>
			</template>
		</template>

		<template v-else>
			<div class="full box">
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item :name="index" v-for="(item,index) in report" :key="index">
						<template slot="title">
							<div style="font-size: 14px;font-weight: bold;">{{index}}</div>
						</template>
						<el-row>
							<el-col style="margin-bottom: 0px;" :span="4" v-for="(_item,_index) in item" :key="_index">
								<el-link :underline="true" @click="open(_item.id,_item.component,_item.name)"><i
										style="color: #67C23A;"
										class="el-icon-s-marketing el-icon--left"></i>{{_item.name}}
								</el-link>
							</el-col>
						</el-row>
					</el-collapse-item>
				</el-collapse>

				<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
			</div>
		</template>
	</div>


</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 4px 20px;
		overflow: auto;
	}

	.item {
		flex-direction: row;
		align-items: center;
	}
</style>
<script>
	export default {
		name: 'reportIndex',
		props: {

		},
		data() {
			return {
				activeNames: [],
				report: [],
				formwindowShow: false,
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
				},
				device: window.systemMethods.device(),
			}
		},
		watch: {

		},
		created() {
			this.list()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			formBack(e) {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (e.type != 'cancle') {
					this.customreload()
				}
			},
			list() {
				return new Promise((resolve) => {
					let obj = {}
					this.$api.report.list().then((res) => {

						res.list.forEach((item) => {
							if (!obj[item.group]) {
								this.activeNames.push(String(item.group))
								obj[item.group] = []
							}
							if (item.component) {
								obj[item.group].push(item)
							}

						})

						this.report = obj

						resolve()
					})
				})
			},
			open(id, component, name) {
				let res = this.$router.resolve({
					name: 'report',
					query: {
						name: component,
						reportName: name
					}
				})
				
				if (this.device != 'pc') {
					this.$router.push(res.href.replace(/#/g, ''))
				} else {
					let win = window.open(res.href, component + "report",
						"toolbar=no,width=1600,height=900,resizable=no")
					win.onload = () => {
						console.log(component + '_report open')
					}
				}
				

			},
			handleChange() {

			}
		},
		components: {

		}
	}
</script>
